import axiosInstance from "@/lib/axiosInstance";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import { viewPreferencesEndpoints } from "./viewPreferences.endpoints";
import type {
  ISaveViewPreferencesPayload,
  IViewPreferencesResponse,
} from "./viewPreferences.queries.types";

export const ViewPreferencesQueryKeys = {
  get: "viewPreferences",
} as const;

export const getViewPreferences = async (
  viewName: string,
): Promise<IViewPreferencesResponse | null> => {
  const url = `${viewPreferencesEndpoints.viewPreferences}/${viewName}`;
  try {
    const response = await axiosInstance.get<{ data: IViewPreferencesResponse }>(url, {
      suppressErrorAlert: true,
    } as CustomAxiosRequestConfig);
    return response.data.data;
  } catch {
    // No saved preferences found — treat as empty
    return null;
  }
};

export const saveViewPreferences = async (
  viewName: string,
  payload: ISaveViewPreferencesPayload,
): Promise<void> => {
  const url = `${viewPreferencesEndpoints.viewPreferences}/${viewName}`;
  await axiosInstance.put(url, payload);
};

export const deleteAllFilterPreferences = async () => {
  const url = `${viewPreferencesEndpoints.deleteAll}`;
  await axiosInstance.delete(url);
};
